export default __webpack_public_path__ + "static/media/coffeepass_web_logo_interior.27f43b5d.png";